var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoMatchesYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "78px",
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoMatchesYet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-13.8%",
    y: "-15.1%",
    width: "127.6%",
    height: "130.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.5312345,4.65705243 C-1.24705264,10.863538 -1.24043607,20.8269799 4.5312345,27.0383764 L28.0989666,52.4065711 C28.3304221,52.6577112 28.6523875,52.8 28.9892016,52.8 C29.3260158,52.8 29.6479811,52.6577112 29.8794366,52.4065711 C37.7428624,43.9603365 45.6027974,35.5044812 53.4662845,27.0580579 C59.2445718,20.8514653 59.2445718,10.8832887 53.4662845,4.67670245 C47.6880585,-1.52987749 38.2423522,-1.53001582 32.4640649,4.67670245 L28.9987589,8.39055439 L25.5335142,4.65705243 C22.6443399,1.55375932 18.826579,0 15.0227864,0 C11.2189939,0 7.42034753,1.55375304 4.5312345,4.65705243 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0453052,2.11684202 C46.3166696,4.93797184 46.3197941,9.46680903 49.0453052,12.2901711 L60.174512,23.8211687 C60.2838104,23.9353233 60.4358496,24 60.5949008,24 C60.7539519,24 60.9059911,23.9353233 61.0152895,23.8211687 C64.7285739,19.9819711 68.4402099,16.1384005 72.1535232,12.2991172 C74.8821589,9.4779388 74.8821589,4.94694939 72.1535232,2.12577384 C69.4249165,-0.695398858 64.9644441,-0.695461738 62.2358084,2.12577384 L60.5994139,3.81388836 L58.9630484,2.11684202 C57.598716,0.706254238 55.7958845,0 53.9996491,0 C52.2034138,0 50.4096086,0.70625138 49.0453052,2.11684202 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Matches-empty-state-no-statement",
    transform: "translate(-155.000000, -300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icNoMatchesYet",
    transform: "translate(158.600000, 300.200000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    filter: "url(#filter-1)",
    transform: "translate(0.400000, 20.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillOpacity: 0.6,
    fill: "#666666",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillOpacity: 0.6,
    fill: "#666666",
    xlinkHref: "#path-4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoMatchesYet);
export default __webpack_public_path__ + "static/media/icNoMatchesYet.8bb9073b16a993125d4983f3ad25a4be.svg";
export { ForwardRef as ReactComponent };